<template>
  <div>
    <popupBox v-if="showPopup"></popupBox>
    <router-view></router-view>
  </div>
</template>

<script>
import PopupBox from "@/components/PopupBox.vue";
export default {
  name: "App",
  components: {
    PopupBox,
  },
  computed: {
    showPopup() {
      return this.$store.getters.getShowPopup
    }
  }
};
</script>

<style lang="scss">
:root {
  --app-height: 100%;
  margin: 0 auto;
}
#app {
  font-family: DIN Condensed Bold, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  text-align: center;
  color: var(--white);
}
body {
  height: var(--app-height);
  width: 100vw;
  background-size: 100%;
  margin: 0;
  align-content: center;
  --white: #FFFFFF;
  --orange: #FFCC88;
  --light-blue: #BFEAFF;
  --blue: #66AADD;
  --dark-blue: #4477AA;
  --indigo: #002266;
  --black: #000000;
  --transparent-black: #00000088;
  background-color: var(--dark-blue);
}

@font-face {
  font-family: "Kefa";
  src: url(assets/fonts/kefa-bold.ttf) format("truetype");
}
h1 {
  font-family: "Kefa", sans-serif;
  font-size: 2em;
  line-height: 1em;
  letter-spacing: 0em;
  font-weight: inherit;
}
h2 {
  font-family: "Kefa", sans-serif;
  font-size: 1.25em;
  line-height: 1.125em;
  letter-spacing: 0em;
  font-weight: inherit;
}
p {
  font-family: "Kefa", sans-serif;
  font-size: 1em;
  letter-spacing: 0em;
  font-weight: inherit;
}
.drop-shadow {
  filter: drop-shadow(0 0 0.1em var(--indigo))
          drop-shadow(0 0 0.1em var(--indigo))
          drop-shadow(0 0 0.1em var(--indigo));
}

.voc-logo { background-image: url('./assets/icons/voc_logo.png'); }
.pepper { background-image: url('./assets/icons/pepper.png'); }
.nutmeg { background-image: url('./assets/icons/nutmeg.png'); }
.mace { background-image: url('./assets/icons/mace.png'); }
.cardamon { background-image: url('./assets/icons/cardamon.png'); }
.tulips { background-image: url('./assets/icons/tulips.png'); }
.porcelain { background-image: url('./assets/icons/porcelain.png'); }
.sugar { background-image: url('./assets/icons/sugar.png'); }
.luxury-goods { background-image: url('./assets/icons/luxury_goods.png'); }
.silver { background-image: url('./assets/icons/silver.png'); }
.cloves { background-image: url('./assets/icons/cloves.png'); }
.gemstones { background-image: url('./assets/icons/gemstones.png'); }
.cinnamon { background-image: url('./assets/icons/cinnamon.png'); }
.yarn { background-image: url('./assets/icons/yarn.png'); }
.copper { background-image: url('./assets/icons/copper.png'); }
.silk { background-image: url('./assets/icons/silk.png'); }
.star-anise { background-image: url('./assets/icons/star_anise.png'); }
.tea { background-image: url('./assets/icons/tea.png'); }
.coffee { background-image: url('./assets/icons/coffee.png'); }
.ivory { background-image: url('./assets/icons/ivory.png'); }
.lacquer { background-image: url('./assets/icons/lacquer.png'); }
.gold { background-image: url('./assets/icons/gold.png'); }
.cloth { background-image: url('./assets/icons/cloth.png'); }
.areca-nuts { background-image: url('./assets/icons/areca_nuts.png'); }
.slaves { background-image: url('./assets/icons/slaves.png'); }
.route-1 { background-image: url("./assets/routes/trade_route_1.png"); }
.route-2 { background-image: url("./assets/routes/trade_route_2.png"); }
.route-3 { background-image: url("./assets/routes/trade_route_3.png"); }
.route-4 { background-image: url("./assets/routes/trade_route_4.png"); }
.route-5 { background-image: url("./assets/routes/trade_route_5.png"); }
.route-6 { background-image: url("./assets/routes/trade_route_6.png"); }
.route-7 { background-image: url("./assets/routes/trade_route_7.png"); }
.route-8 { background-image: url("./assets/routes/trade_route_8.png"); }
.netherlands { background-image: url("./assets/flags/netherlands.svg"); }
.cape-town { background-image: url("./assets/flags/cape_town.svg"); }
.sri-lanka { background-image: url("./assets/flags/sri_lanka.svg"); }
.indonesia { background-image: url("./assets/flags/indonesia.svg"); }
.malaku { background-image: url("./assets/flags/malaku.jpg"); }
.wik-country { background-image: url("./assets/flags/wik_country.jpg"); }
.arabia { background-image: url("./assets/flags/arabia.jpg"); }
.india { background-image: url("./assets/flags/india.svg"); }
.china { background-image: url("./assets/flags/china.svg"); }
.japan { background-image: url("./assets/flags/japan.svg"); }
.western-australia { background-image: url("./assets/flags/western_australia.jpg"); }
</style>